export enum QueryBuilderTypes {
    Wizard = "wizard",
    Advanced = "advanced",
}